import * as Constants from '../constants';
import Api from '../lib/Api';

export function addTrackingCode(trackingCode) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.ADD_TRACKING_CODE,
    content: {
      trackingCode,
    },
  });
}

export function updateAccount(content) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.UPDATE_ACCOUNT,
    content,
  });
}

const holdoutGroupKeys = [
  'WEB_2019_HOLDOUT_GROUP',
  'ADS_AD_EXPERIENCE_2019_HOLDOUT_GROUP',
  'WEB_2020_HOLDOUT_GROUP',
  'QUALITY_OF_SERVICE_2020_HOLDOUT_GROUP',
  'QUALITY_OF_SERVICE_2021_HOLDOUT_GROUP',
  'QOS_2022_HOLDOUT_GROUP',
  'ADS_EXPERIENCE_2022',
  'QOS_2023_HOLDOUT_GROUP',
].join(',');

export function getExperimentsForListener() {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.GET_EXPERIMENTS_FOR_LISTENER,
    content: {
      holdoutGroupKeys,
    },
  });
}
